
import React, { useEffect, useRef, useState,useMemo } from 'react';
import { IsPhone,IsEmail,isOnlyNo  } from '@/utils/utils';
import { encrypt, decrypt  } from '@/utils/crypto';

import { dataStatistics  } from '@/utils/monitor';

import './index.less';

const HomePage = (props) => {
  
  const { history } = props;
  const [usersubstate, setUsersubstate] = useState(false);
  const [substate, setSubstate] = useState(false);
  const [layerstate, setLayerstate] = useState(1);
  const [userinfostate,setUserinfostate] = useState(0)
  const [loginemail,setLoginemail] = useState('')


  const [cansub,setCansub] = useState(true)

  const [loadingstate,setLoadingstate] = useState(false)

  const [sourcelist,setSourcelsit] = useState([2,4,5,6,7,8])

  const [loginstate,setLoginstate] = useState(true)
  const [loginstateerror,setLoginstateerror] = useState(false)

  const [errortextemail,setErrortextemail] = useState("未搜索到该邮箱的报名信息，请检查输入是否正确。如未报名请点击注册按钮报名。")

  useEffect(() => {
    dataStatistics()
  },[])



  const changelayerstate = (ids) =>{
    if(ids==4){
      dataStatistics("click","已报名？点此登录")
      setLoginstate(true)
      return;
    }
    if(ids==3){
      dataStatistics("click","预约会议提醒")
    }
    setSubstate(true)
    setLayerstate(ids)
  }

  const getUrlkey = (url) =>{
    var params = {};
    var urls = url.split("?");                  //////console.log('1_分割url:', urls)
    var arr = urls[1].split("&");               //////console.log('2_分割urls[1]:', arr)
    for (var i = 0, l = arr.length; i < l; i++) {
      var a = arr[i].split("=");                //////console.log('3_遍历 arr 并分割后赋值给a:', a[0], a[1])
      params[a[0]] = a[1];                      //////console.log('4_a给params对象赋值:', params)
    }                                           //////console.log('5_结果:', params)
    return params;
  }
  const selectyesbox = ['请选择',"是",'否']
 

  const provinceData = ['请选择','安徽', '澳门', '北京', '福建', '甘肃', '广东', '广西', '贵州', '海南', '河北', '河南', '黑龙江', '湖北', '湖南', '吉林', '江苏', '江西', '辽宁', '内蒙古', '宁夏', '青海', '山东', '山西', '陕西', '上海', '四川', '台湾', '天津', '西藏', '香港', '新疆', '云南', '浙江', '重庆']
  const cityData = {
    '请选择':'请选择',
    '安徽': ['合肥', '安庆', '蚌埠', '亳州', '巢湖', '池州', '滁州', '阜阳', '淮北', '淮南', '黄山', '六安', '马鞍山', '宿州', '铜陵', '芜湖', '宣城'],
    '澳门': ['澳门'],
    '北京': ['北京'],
    '福建': ['福州', '龙岩', '南平', '宁德', '莆田', '泉州', '三明', '厦门', '漳州'],
    '甘肃': ['兰州', '白银', '定西', '甘南', '嘉峪关', '金昌', '酒泉', '临夏', '陇南', '平凉', '庆阳', '天水', '武威', '张掖'],
    '广东': ['广州', '潮州', '东莞', '佛山', '河源', '惠州', '江门', '揭阳', '茂名', '梅州', '清远', '汕头', '汕尾', '韶关', '深圳', '阳江', '云浮', '湛江', '肇庆', '中山', '珠海'],
    '广西': ['桂林', '百色', '北海', '崇左', '防城港', '贵港', '河池', '贺州', '来宾', '柳州', '南宁', '钦州', '梧州', '玉林'],
    '贵州': ['贵阳', '安顺', '毕节', '六盘水', '黔东南', '黔南', '黔西南', '铜仁', '遵义'],
    '海南': ['海口', '白沙', '保亭', '昌江', '澄迈', '儋州', '定安', '东方', '乐东', '临高', '陵水', '南沙群岛', '琼海', '琼中', '三亚', '屯昌', '万宁', '文昌', '五指山', '西沙群岛', '中沙群岛'],
    '河北': ['石家庄', '保定', '沧州', '承德', '邯郸', '衡水', '廊坊', '秦皇岛', '唐山', '邢台', '张家口'],
    '河南': ['郑州', '安阳', '鹤壁', '焦作', '济源', '开封', '洛阳', '漯河', '南阳', '平顶山', '濮阳', '三门峡', '商丘', '新乡', '信阳', '许昌', '周口', '驻马店'],
    '黑龙江': ['哈尔滨', '大庆', '大兴安岭', '鹤岗', '黑河', '鸡西', '佳木斯', '牡丹江', '七台河', '齐齐哈尔', '双鸭山', '绥化', '伊春'],
    '湖北': ['武汉', '鄂州', '恩施', '黄冈', '黄石', '荆门', '荆州', '潜江', '神农架', '十堰', '随州', '天门', '仙桃', '咸宁', '襄樊', '孝感', '宜昌'],
    '湖南': ['长沙', '常德', '郴州', '衡阳', '怀化', '娄底', '邵阳', '湘潭', '湘西', '益阳', '永州', '岳阳', '张家界', '株洲'],
    '吉林': ['长春', '白城', '白山', '吉林', '辽源', '四平', '松原', '通化', '延边'],
    '江苏': ['南京', '常州', '淮安', '连云港', '南通', '苏州', '宿迁', '泰州', '无锡', '徐州', '盐城', '扬州', '镇江'],
    '江西': ['南昌', '抚州', '赣州', '吉安', '景德镇', '九江', '萍乡', '上饶', '新余', '宜春', '鹰潭'],
    '辽宁': ['沈阳', '鞍山', '本溪', '朝阳市', '大连', '丹东', '抚顺', '阜新', '葫芦岛', '锦州', '辽阳', '盘锦', '铁岭', '营口'],
    '内蒙古': ['呼和浩特', '阿拉善', '巴彦淖尔', '包头', '赤峰', '鄂尔多斯', '呼伦贝尔', '通辽', '乌海', '乌兰察布', '锡林郭勒', '兴安'],
    '宁夏': ['银川', '固原', '石嘴山', '吴忠', '中卫'],
    '青海': ['西宁', '果洛', '海北', '海东', '海南', '海西', '黄南', '玉树'],
    '山东': ['济南', '滨州', '德州', '东营', '菏泽', '济宁', '莱芜', '聊城', '临沂', '青岛', '日照', '泰安', '威海', '潍坊', '烟台', '枣庄', '淄博'],
    '山西': ['太原', '长治', '大同', '晋城', '晋中', '临汾', '吕梁', '朔州', '忻州', '阳泉', '运城'],
    '陕西': ['西安', '安康', '宝鸡', '汉中', '商洛', '铜川', '渭南', '咸阳', '延安', '榆林'],
    '上海': ['上海'],
    '四川': ['成都', '阿坝', '巴中', '达州', '德阳', '甘孜', '广安', '广元', '乐山', '凉山', '泸州', '眉山', '绵阳', '内江', '南充', '攀枝花', '遂宁', '雅安', '宜宾', '资阳', '自贡'],
    '台湾': ['台北', '阿莲', '安定', '安平', '八德', '八里', '白河', '白沙市', '板桥', '褒忠', '宝山市', '卑南', '北斗', '北港', '北门', '北埔', '北投', '补子', '布袋', '草屯', '长宾', '长治市', '潮州市', '车城', '成功', '城中区', '池上', '春日', '刺桐', '高雄', '花莲', '基隆', '嘉义', '苗栗', '南投', '屏东', '台东', '台南', '台中', '桃园', '新竹', '宜兰', '彰化'],
    '天津': ['天津'],
    '西藏': ['拉萨', '阿里', '昌都', '林芝', '那曲', '日喀则', '山南'],
    '香港': ['北区', '大埔区', '东区', '观塘区', '黄大仙区', '九龙', '葵青区', '离岛区', '南区', '荃湾区', '沙田区', '深水?肚?', '屯门区', '湾仔区', '西贡区', '香港', '新界', '油尖旺区', '元朗区', '中西区'],
    '新疆': ['乌鲁木齐', '阿克苏', '阿拉尔', '阿勒泰', '巴音郭楞', '博尔塔拉', '昌吉', '哈密', '和田', '喀什', '克拉玛依', '克孜勒苏柯尔克孜', '石河子', '塔城', '图木舒克', '吐鲁番', '五家渠', '伊犁'],
    '云南': ['昆明', '保山', '楚雄', '大理', '德宏', '迪庆', '红河', '丽江', '临沧', '怒江', '曲靖', '思茅', '文山', '西双版纳', '玉溪', '昭通'],
    '浙江': ['杭州', '湖州', '嘉兴', '金华', '丽水', '宁波', '衢州', '绍兴', '台州', '温州', '舟山'],
    '重庆': ['重庆'],
    '其他': ['阿根廷', '埃及', '爱尔兰', '奥地利', '奥克兰', '澳大利亚', '巴基斯坦', '巴西', '保加利亚', '比利时', '冰岛', '朝鲜', '丹麦', '德国', '俄罗斯', '法国', '菲律宾', '芬兰', '哥伦比亚', '韩国', '荷兰', '加拿大', '柬埔寨', '喀麦隆', '老挝', '卢森堡', '罗马尼亚', '马达加斯加', '马来西亚', '毛里求斯', '美国', '秘鲁', '缅甸', '墨西哥', '南非', '尼泊尔', '挪威', '葡萄牙', '其它地区', '日本', '瑞典', '瑞士', '斯里兰卡', '泰国', '土耳其', '委内瑞拉', '文莱', '乌克兰', '西班牙', '希腊', '新加坡', '新西兰', '匈牙利', '以色列', '意大利', '印度', '印度尼西亚', '英国', '越南', '智利']
  };

const [joblist,setJoblist] = useState(['','科技行业',
'医疗行业',
'工业行业',
'消费品行业',
'保险与支付业',
'公募基金',
'投资银行',
'私募股权投资',
'对冲基金',
'信贷业务',
'咨询公司',
'市场研究公司',
'市场及广告公司',
'其他'])
  const [userlist, setUserlist] = useState({
    first_name:'',
    last_name:'',
    company:'',
    phone:'',
    email:'',
    province:'',
    city:'',
    industry:'',
    is_interest:'',
    source:'2',
    source_id:'92',
    position: ''
  });
  const clearuserlist = () =>{
    window.location.href=window.location.href
  }
  const selectchange = (e) =>{
    setUsersubstate(!usersubstate)
    userlist['industry'] = e.target.value
    setUserlist(userlist);
  }

  const selectchangeprovince = (e) =>{
    setUsersubstate(!usersubstate)
    userlist['province'] = e.target.value
    userlist['city'] = ''
    setUserlist(userlist);
  }

  const selectchangecity = (e) =>{
    setUsersubstate(!usersubstate)
    userlist['city'] = e.target.value
    setUserlist(userlist);
  }

  const selectchangeis_interest = (e) =>{
    setUsersubstate(!usersubstate)
    userlist['is_interest'] = e.target.value
    setUserlist(userlist);
  }

  const valueChange = (e) =>{
    userlist[e.target.name] = e.target.value
    setUsersubstate(!usersubstate)
    setUserlist(userlist);
  }
  const valueChangeEmail = (e) =>{
    setLoginemail( e.target.value)
    if(IsEmail(loginemail) && loginemail){
      setLoginstateerror(false)
    }
  }
  const layer = () =>{
    return <div className="layer">
      <div className="codebox" style={{height:layerstate==4?"100px":""}}>
        {layerstate==1?<div className="code_tips">报名成功!</div>:null}
        {layerstate==2? <div className="codeimg"><img src={require("../../static/activecode.jpg")} /></div>:
          layerstate==3 || layerstate==1?<div className="codeimg"><img src={require("../../static/tempcode.jpg")} /></div>:null
        }
       
        <div className="code_title">{layerstate==4?"请先进行注册!":layerstate==3||layerstate==2||layerstate==1?"关注我们":null}</div>
        <div className="code_desc">{layerstate==2?"查看活动详细资料":layerstate==3||layerstate==1?"会前30分钟给您发送会议提醒":"待活动开始时开放登录功能。感谢！" }</div>
      </div>
      <div className="codeclose cursor" onClick={clearuserlist}></div>
    </div>
  }
  const sub = ()=>{
    console.log(userlist)
    console.log(IsEmail(userlist['email']))
    console.log(isOnlyNo(userlist['phone']))
  
    if(!userlist['first_name'] || 
    !userlist['last_name'] || 
    !userlist['position'] || 
    !userlist['company'] || 
    !userlist['phone'] || 
    !userlist['email'] || 
    !userlist['province'] || 
    userlist['province']=='请选择' ||
    !userlist['city'] || 
    userlist['city']=='请选择' ||
    !userlist['industry'] || 
    userlist['industry']=='请选择' ||
    userlist['industry']==0 ||
    !userlist['is_interest'] || 
    userlist['is_interest']=='请选择' ||
    !userlist['source'] || 
    !userlist['source_id'] || !isOnlyNo(userlist['phone']) ||userlist['phone'].length < 7 || !IsEmail(userlist['email'])){
      if(!IsEmail(userlist['email']) && userlist['email']){
        alert('请输入正确邮箱')
      }else if( (!isOnlyNo(userlist['phone'])  || userlist['phone'].length < 7  ) && userlist['phone'] ){
        alert('请输入正确办公电话')
      }else{
        alert('请输入');
      }
      console.log(userlist)
      return
    }else{
      let ids=2;
      let urls = '';
      if(window.location.href.indexOf('?')>=0){
       
        urls =  getUrlkey(window.location.href)
        ids=urls.source
        
      }
      let source_id =urls.id?urls.id:userlist['source_id'] 
      let subuserlisttemp ={};
      subuserlisttemp['first_name'] = encrypt(userlist['first_name'])  
      subuserlisttemp['last_name'] = encrypt(userlist['last_name'])  
      subuserlisttemp['company'] = encrypt(userlist['company'])  
      subuserlisttemp['phone'] = encrypt(userlist['phone'])  
      subuserlisttemp['email'] = encrypt(userlist['email'])  
      subuserlisttemp['position'] = userlist['position']  
      subuserlisttemp['province'] = userlist['province']  
      subuserlisttemp['city'] = userlist['city']  
      subuserlisttemp['industry'] = userlist['industry']  
      subuserlisttemp['is_interest'] = userlist['is_interest']  
     // subuserlisttemp['source'] = userlist['source']  
      subuserlisttemp['source'] = ids
      subuserlisttemp['source_id'] = source_id
      setCansub(false)
      setLoadingstate(true)
      if(!cansub){
        return false
      }
      React.$request({
        method: "post",
        url: '/api/platform/enroll/collect',
        data: subuserlisttemp,
      }).then(res => {
        console.log(res)
        setLoadingstate(false)
        if(res.data.code==1000){
          changelayerstate(1)
          setSubstate(true)
        }else{
          alert("您已报名，请于活动时间登录参会")
        }
        setCansub(true)
      }).catch(() => {
        console.log(12222)
      });
    }


    // React.$request({
    //   method: "post",
    //   url: '/api/platform/enroll/collect',
    //   data: userlist,
    // }).then(res => {
    //   console.log(res)
    // }).catch(() => {
    //   console.log(12222)
    // });
  }
  const clearuserinfo = (id,keyword='') =>{
    dataStatistics("click",keyword)
    setUserinfostate(id)
  }
  const goreg =() =>{
      console.log(111)
      setLoginstate(false)
  }
  const gologin = () =>{
    console.log(loginemail)
    if(!loginemail){
      setLoginstateerror(true)

      setErrortextemail("请输入邮箱")
      return false
    }else if(!IsEmail(loginemail) && loginemail){
      setLoginstateerror(true)

      setErrortextemail("请输入正确邮箱")
    }else{
      if(loginstate){
        let ids=92;
        if(window.location.href.indexOf('?')>=0){
          let urls =  getUrlkey(window.location.href)
          ids=urls.id
        }
        console.log()
        let date=new Date('2022-08-17 14:55:00')
        let datetime = date.getTime();

       
        React.$request({
          method: "post",
          url: '/api/platform/activity/check/login',
          data: {
            email:encrypt(loginemail),
            source_id:ids
          },
        }).then(res => {
          console.log(res.data.code)
          console.log(res.data)
          if(res.data.code==1000 && res.data.data.is_login !=1 ){
            setLoginstateerror(true)
            setErrortextemail("未搜索到该邮箱的报名信息，请检查输入是否正确。如未报名请点击注册按钮报名。")
          }else if(datetime>Date.now()){
            setLoginstateerror(true)
            setErrortextemail("活动暂未开启")
          }else{

            localStorage.setItem("is_login",1);
            localStorage.setItem("enroll_id",res.data.data.enroll_id);
            let ids=92;
            
            if(window.location.href.indexOf('?')>=0){
              let urls =  getUrlkey(window.location.href)
              ids=urls.id
            }  
            history.push("/video?id="+ids)
          }
          
        }).catch(() => {

          console.log(12222)
        });


        console.log('gologin')
      }
    }
  }

  const layertext = () =>{
    console.log(userinfostate)
    return <div className="layer">

    {userinfostate==1?<div className="userinfotip">彭澎女士，自 2018 年 3 月起担任中国新能源电力投资联盟秘书长。在此之前，她从2012年6月至2018年2月担任中国循环经济协会可再生能源专业委员会（CREIA）的政策研究总监。中国循环经济协会可再生能源专业委员会是政策研究和监管机构，也是讨论国家可再生能源发展，就战略政策制定向中国政府提供建议的机构。彭女士负责太阳能和风能的政策研究，行业研究和改革研究。她负责年度报告，如《 2012-2015中国风电展望》，《 2012-2015中国光伏展望》，《中国太阳能光伏电力政策报告-差别上网电价》，《改善硅的出口退税》，《投资研究》和《支持中国分布式太阳能光伏产业发展的融资机制。在从事太阳能和风能政策研究之前，她在2009年3月至2012年6月在中国北京环境交易所担任合作与发展总监。她负责金融企业，碳投资公司和碳交易之间的贸易往来。她同时还负责低碳经济的研究。  </div>:userinfostate==2?<div className="userinfotip">张拥军先生，2018年至今在上海镁初新能源发展有限公司担任执董，该公司是一家新能源投资公司，经营范围为新能源和新材料。2008年至2018年，张先生曾受聘于多家国际知名电力能源机构，担任投资高级顾问，主要从事风电、光伏、综合能源服务、环保节能等新能源和环保市场的开发研究，是可再生能源方面的专家。2017年4月至2018年3月曾在北控清洁能源集团担任总监；2009年1月至2017年3月曾在金风科技公司任职。 张先生主持过国内多个风电、光伏、微电网等可再生能源项目的开发建设，处理过华能集团、中电建集团、金风科技等能源电力大型企业的多个电力能源项目工作。张先生是天宏阳光新能源和同创明志科技的非执行董事。 </div>:userinfostate==3?<div className="userinfotip">刘顺成先生，自2019年12月至今，在南京金智竞泰储能科技有限公司（更名前为江苏金智竞泰储能科技有限公司）担任总经理。 自2018年7月至2019年12月，在江苏金智竞泰储能科技有限公司担任总经理。 自2016年11月至2018年6月，在江苏杉杉能源管理有限公司担任副总经理。 自2015年7月至2016年11月，在国电远鹏能源科技股份有限公司担任执行总裁、董秘。 自2014年5月至2015年7月，在广东易事特电源股份有限公司担任副总裁。 自2013年1月自2014年5月，在曦谷（苏州）电力投资发展有限公司担任CTO, 副总裁。 自2010年5月至2013年1月，在协鑫光伏（国际）有限公司担任供应链副总经理。 自2008年3月至2010年5月，在无锡尚德太阳能电力有限公司担任高级采购经理。</div>:null}
      <div className="codeclose cursor" onClick={()=>clearuserinfo(0)}></div>
    </div>
  }
  const subloadding = () =>{
    return <div className="loaddinglayer">
      <div className="loadingtext">提交中！</div>
    </div>
  }
  return <div className="home_page">
    {/* {layer()} */}
    {loadingstate?subloadding():null}
    {userinfostate>0?layertext():null}
    {substate?layer():null}
    <div className="home_box">

      <div className="home_box_addtips_titlelist"><p>请注意，专家们将从能源行业从业者的角度来谈论这些话题，他们不会讨论中国新能源电力投资联盟和上海镁初新能源发展有限公司及其运营有关的任何问题。他们也将拒绝回答与保密事项有关的问题。</p>
      <p>请注意，GLG格理集团本次将邀请包括企业、金融服务及专业服务等多个行业客户及专家参加本次活动。如果您或您的合规团队有任何问题，请随时与我们联系。 </p>
      <p>活动期间严禁参与者录音或截屏。GLG可能会对会议进行录像以供会议回放使用。与会者的提问或评论将不会被公开（无论是姓名还是姓氏）。在会议中提供的相关信息将仅供您参考。演讲人表达的观点和见解属于演讲人，GLG不对内容负责。</p> </div>
      <div className="home_left">
        <div className="home_left_title">公开网上会议 </div>
        <div className="home_left_desc">“碳中和”下的风电光伏产业及储能配套发展 </div>
        <div className="home_left_time">2022年8月17日  下午3:00 - 4:30 </div>
        <div className="home_left_tipsbox">
          {/* <div className="home_left_tipsfile cursor"  onClick={()=>changelayerstate(2)}>查看活动资料</div> */}
          <div className="home_left_tipsmeeting cursor" onClick={()=>changelayerstate(3)}>预约会议提醒<p className='home_tips_left_p'>*点击预约会前半小时入会提醒</p></div>
          
        </div>
        <div className="home_left_line"></div>
        <div className="home_left_topic_title">“碳中和”下的风电光伏产业及储能配套发展 </div>
        <div className="home_left_topic_list">
          <div className="home_left_topic_li">碳中和政策体系及对能源产业的影响：国家核证自愿减排量（CCER） </div>
          <div className="home_left_topic_li">碳中和配套设施发展趋势：绿色金融与碳排放交易 </div>
          <div className="home_left_topic_li">碳中和背景下风电、光伏产业的发展现状和未来趋势：主流技术路线图，头部企业分析  </div>
          <div className="home_left_topic_li">储能行业的发展与商业模式展望：主流储能方式分析，关键技术进展 </div>
        </div>
        <div className="home_left_userlist">
          <div className="home_left_userlist_li" onClick={()=>clearuserinfo(1,"彭澎女士")}>
            <div className="home_left_userlist_li_img"><img src={require("../../static/topic_user1.jpg")} /></div>
            <div className="home_left_userlist_li_text">
              <p>彭澎女士</p>
              <div>中国新能源电力投资联盟秘书长</div>
              <div className="addtips">*点击查看主讲人详细资料</div>
            </div>
          </div>

          <div className="home_left_userlist_li" onClick={()=>clearuserinfo(2,"张拥军先生")}>
            <div className="home_left_userlist_li_img"><img src={require("../../static/topic_user2.png")} /></div>
            <div className="home_left_userlist_li_text">
              <p>张拥军先生</p>
              <div>前北控清洁能源集团总监</div>
              <div className="addtips">*点击查看主讲人详细资料</div>
            </div>
          </div>

          <div className="home_left_userlist_li" onClick={()=>clearuserinfo(3,"刘顺成先生")}>
            <div className="home_left_userlist_li_img"><img src={require("../../static/topic_user3.png")} /></div>
            <div className="home_left_userlist_li_text">
              <p>刘顺成先生</p>
              <div>南京金智竞泰储能科技有限公司总经理</div>
              <div className="addtips">*点击查看主讲人详细资料</div>
            </div>
          </div>


        </div>
      </div>


      {loginstate?<div className="home_login">
        <div className="home_sign_title">请输入您的报名邮箱</div>
          <div className="login_inputbox">
            <input type="" 
              name="loginemail"
              onChange={valueChangeEmail}
          />
          </div>
{loginstateerror? <div className="loginemalerror">{errortextemail}</div>:null}
          <div className="home_login_btnlist">
            <div className="home_login_btnreg" onClick={goreg}>尚未报名，注册参会</div>
            <div className="home_login_btn" onClick={gologin}>已经报名，登录参会</div>
          </div>
      </div>: <div className="home_reg">
        <div className="home_sign_title">立即免费报名此次活动</div>
        <ul className="home_sign_list">
          <li>
            <div className="sign_input">
              <div className="sign_input_title one">姓</div>
              <div className="sign_input_box one"><input type="" 
                 name="first_name"
                 onChange={valueChange}

              /></div>
            </div>
            <div className="sign_input more">
              <div className="sign_input_title one">名</div>
              <div className="sign_input_box one"><input type=""
                 name="last_name"
                 onChange={valueChange}
                  /></div>
            </div>
          </li>

          <li>
            <div className="sign_input">
              <div className="sign_input_title two">公司</div>
              <div className="sign_input_box two"><input type=""
                 name="company"
                 onChange={valueChange}
                  /></div>
            </div>
          </li>

          <li>
            <div className="sign_input">
              <div className="sign_input_title four">办公电话</div>
              <div className="sign_input_box four"><input type="number" 
                 name="phone"
                 onChange={valueChange} /></div>
            </div>
          </li>

          <li>
            <div className="sign_input">
              <div className="sign_input_title four">职位</div>
              <div className="sign_input_box four"><input type="" 
                 name="position"
                 onChange={valueChange} /></div>
            </div>
          </li>

          <li>
            <div className="sign_input">
              <div className="sign_input_title four">办公邮箱</div>
              <div className="sign_input_box four"><input type="" 
                 name="email"
                 onChange={valueChange}
                 /></div>
            </div>
          </li>


          <li>
            <div className="sign_input">
              <div className="sign_input_title five">请选择行业</div>
              <div className="sign_input_box five">
                
              <select className="" onChange={selectchange}>
                <option value="0">请选择</option>
                <option value="1">科技行业</option>
                <option value="2">医疗行业</option>
                <option value="3">工业行业</option>
                <option value="4">消费品行业</option>
                <option value="5">保险与支付业</option>
                <option value="6">公募基金</option>
                <option value="7">投资银行</option>
                <option value="8">私募股权投资</option>
                <option value="9">对冲基金</option>
                <option value="10">信贷业务</option>
                <option value="11">咨询公司</option>
                <option value="12">市场研究公司</option>
                <option value="13">市场及广告公司</option>
                <option value="14">其他</option>
              </select>
              <div className="cityname">{joblist[userlist['industry']]}</div>
              <span className="sign_select_arrow"></span>
              
              </div>
            </div>
          </li>


          <li>
            <div className="sign_input">
              <div className="sign_input_title two">城市</div>
              <div className="citylist">
                <div className="cityprovincediv">


                  <select className="cityprovince"  onChange={selectchangeprovince}>
                    {provinceData.map((item,index)=>{
                      return  <option value={item} key={"cityprovince_"+index}>{item}</option>
                    })}
                  </select>
                  <div className="provincename">{userlist['province']}</div>
                  <div className="provincetips">省</div>

                </div>

                <div className="cityprovincediv">


                  <select className="cityprovince"  onChange={selectchangecity} value={userlist['city']}>
                    <option >请选择</option>
                    {userlist['province']&& userlist['province']!='请选择'?cityData[userlist['province']].map((item,index)=>{
                      return <option  value={item} key={"city_"+index}>{item}</option>
                    }):null}
                    
                  </select>

                  <div className="cityname">{userlist['city']}</div>
                  <div className="citytips ">市<span></span></div>

                </div>

              </div>
            </div>
          </li>

          <li className="li_text">您是否有兴趣使用GLG格理集团的专家咨询服务了解更多行业洞见？</li>
          <li>
           
            <div className="sign_input">
              <div className="sign_input_title two">请选择</div>
              <div className="sign_input_box two">
              <div className="selectoverbox">

                <span></span>
                  <select className="cityprovince"  onChange={selectchangeis_interest}>
                    {selectyesbox.map((item,index)=>{
                      return <option value={item} key={"city_"+index}>{item}</option>
                    })}
          {/*                     
                    <option>是</option>
                    <option>否</option> */}
                  </select>

                  <div className="cityname">{userlist['is_interest']}</div>

                </div>

              </div>
            </div>
          </li>
        </ul>
        <div className="isreg"><span className="cursor"  onClick={()=>changelayerstate(4)}>已报名？点此登录</span></div>
        <div className='submitbtn cursor' onClick={sub}>立即报名</div>
      </div>}
    </div>
  </div>
}

export default HomePage;
